<template>
  <div>
    <div class="search-wrap">
      <div class="search">
        <div class="flex-x">
          <el-input v-model="content" placeholder="请输入搜索的内容" />
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="professorSearch"
            >站内搜索</el-button
          >
        </div>
        <div class="flex-left search-bot">
          <p>搜索域：</p>
          <el-radio-group v-model="label">
            <el-radio
              v-for="(item, i) in labelList"
              :key="i"
              :label="item.id"
              >{{ item.title }}</el-radio
            >
          </el-radio-group>
        </div>
      </div>
    </div>
    <div
      class="expert-base"
      id="main-container"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
    >
      <el-container>
        <el-aside>
          <p class="title">首页/会员之家</p>
          <NavMenu
            :list="listNav"
            @menuChange="selectMenu"
            ref="menu"
          ></NavMenu>
          <ListAdv :ListAdv="ListAdv"></ListAdv>
        </el-aside>
        <el-main>
          <div class="flex-x search-expert">
            <p class="result">找到{{ total }}条相关结果</p>
            <!-- <div class="flex-x">
            <el-input
              v-model="search"
              size="mini"
              style="height: 32px"
              prefix-icon="el-icon-search"
              placeholder="请输入搜索的内容"
            />
            <el-button type="info" size="mini">查询</el-button>
                        </div>-->
          </div>
          <div class="expert-wrap">
            <div
              v-for="single in expertList"
              :key="single.id"
              v-show="expertList.length > 0"
            >
              <HumanCell :isLink="false" :person="single"></HumanCell>
            </div>
          </div>
          <el-pagination
            v-if="total > 0"
            background
            layout="jumper, prev, pager, next, slot, total"
            :total="total"
            :current-page="page"
            @current-change="currentChange"
            @prev-click="prevClick"
            @next-click="nextClick"
          >
            <!-- <span class="el-pagination__total"> 共 {{ pageCount }} 页，</span> -->
          </el-pagination>
        </el-main>
      </el-container>
    </div>
  </div>
</template>

<script>
import HumanCell from '../../components/common/HumanCell'
import NavMenu from '../../components/content/nav-menu'
import ListAdv from '../../components/common/ListAdv'
export default {
  components: {
    ListAdv,
    HumanCell,
    NavMenu
  },
  props: {},
  data() {
    return {
      search: '',
      total: 0,
      label: '',
      content: '',
      current: '',
      ListAdv: [],
      listNav: [],
      expertList: [],
      labelList: [],
      loading: false,
      level: '',
      page: 1,
      size: 10
    }
  },
  computed: {
    pageCount() {
      let count = 0
      let total = Number(this.total)
      if (total) {
        if (total % 10 === 0) {
          count = total / 10
        } else {
          count = Math.floor(total / 10) + 1
        }
      }
      return count
    }
  },
  created() {
    this.getLabel()
    this.getAdvertise()
  },
  mounted() {
    this.listNav = [
      {
        id: '1',
        mname: '个人会员',
        children: []
      },
      {
        id: '3',
        mname: '电厂机组',
        children: []
      },
      {
        id: '2',
        mname: '设备厂商',
        children: []
      },
      {
        id: '5',
        mname: '科研高校',
        children: []
      }
    ]
    this.level = this.listNav[0].id
    this.getExpertList()
  },
  watch: {},
  methods: {
    getAdvertise() {
      this.httpGet(this.$root.getAdvList)
        .then((res) => {
          this.ListAdv = res.DetailList.slice(0, 2)
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
          console.error('ListAdv-err', err)
        })
    },
    getLabel() {
      this.httpGet(this.$root.labelList, {
        page: 1,
        size: 5
      })
        .then((res) => {
          this.labelList = res.list
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
          console.error('expertType-err', err)
        })
    },
    selectMenu(id) {
      this.level = id
      this.expertList = []
      this.getExpertList()
    },
    professorSearch() {
      this.page = 1
      this.method = 'search'
      this.$refs.menu.clearData()
      this.loading = true
      this.httpGet(this.$root.memberSearch, {
        labelid: this.label,
        content: this.content,
        page: this.page,
        size: this.size
      })
        .then((result) => {
          if (result.count) {
            this.expertList = result.list
            this.total = Number(result.count)
          } else {
            this.expertList = []
            this.total = 0
          }
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
          console.error('expertList-err', err)
        })
    },
    getExpertList() {
      this.method = 'list'
      this.loading = true
      this.httpGet(this.$root.getMemberList, {
        level: this.level,
        page: this.page,
        size: this.size
      })
        .then((result) => {
          if (result.count) {
            this.expertList = result.list
            this.total = Number(result.count)
          } else {
            this.expertList = []
            this.total = 0
          }
          this.$nextTick(() => {
            this.loading = false
          })
        })
        .catch((err) => {
          this.loading = false
          console.error('expertList-err', err)
        })
    },
    currentChange(page) {
      this.page = page
      this.expertList = []
      if (this.method == 'search') {
        this.professorSearch()
      } else {
        this.getExpertList()
      }
    },
    prevClick(page) {
      this.page = page
      this.expertList = []
      if (this.method == 'search') {
        this.professorSearch()
      } else {
        this.getExpertList()
      }
    },
    nextClick(page) {
      this.page = page
      this.expertList = []
      if (this.method == 'search') {
        this.professorSearch()
      } else {
        this.getExpertList()
      }
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.flex-x {
    flex-x();
}

.flex-left {
    flex-x(flex-start);
}

#main-container {
    // min-height: 520px;
    margin-top: 20px;
}

.expert-wrap {
    // min-height: 520px;
}

#main-container {
    .title {
        margin-bottom: 26px;
    }

    .result {
        margin-bottom: 10px;
        font-size: 12px;
        color: gray6;
    }
}

.el-main {
    padding: 0 20px;
}

>>>.el-pagination {
    width: 880px;
    flex-center();
    padding: 20px;
    box-sizing: border-box;
    background: white;
    margin-top: 20px;
}

.search-wrap {
    width: 100%;
    background: white;
    height: 180px;
    flex-center();
    padding: 40px;
    box-sizing: border-box;
}

.search {
    width: 740px;

    .search-bot {
        margin-top: 15px;

        p {
            margin-right: 10px;
            color: gray9;
        }
    }

    .search-hot {
        flex-x(flex-start);
        margin-bottom: 10px;

        .title {
            color: gray3;
        }

        p {
            color: gray9;
            margin-right: 30px;
        }
    }
}
</style>
